import React, { Component } from "react";
import LayoutOperation from "../../components/layout_operation";
// import { DownOutlined, MenuOutlined } from "@ant-design/icons";
import {  Select, Radio } from "antd";
// import {
//   Getmaterial,
//   Getsupplire,
//   GetUnit,
//   AddMaterial,
// } from "../../actions/taskAction";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Api from "../../services/ServiceApi";

// function buildFileSelector() {
//   const fileSelector = document.createElement("input");
//   fileSelector.setAttribute("type", "file");
//   fileSelector.setAttribute("multiple", "multiple");
//   return fileSelector;
// }

class Addmaterial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      title: "ADD Material",
      statusbtn: true,
      showMenu: false,
      meterial_list: [],
      get_supplire: [],
      form: {},
      InStock: 0,
      expireDate: new Date(),
      material_type: [],
      model_no: [],
      material_code: [],
      unit_type: [],
      unit_price: [],
      input_brand: [],
    };
  }

  componentDidMount() {
    document.title = "MaxiOperation - Add Material";
    this.props.Getmaterial();
    this.props.Getsupplire();
    this.props.GetUnit();

    console.log(this.props.get_unit);
    this.setState({
      meterial_list: this.props.get_material,
      get_supplire: this.props.get_supplire,
      unit_type: this.props.get_unit,
    });
  }

  handleSelectChange(name, value) {
    var form = this.state.form;
    form[name] = value;
    console.log(value);
    this.setState(form);
  }
  onChange = (e) => {
    this.setState({
      InStock: e.target.value,
    });
  };

  handleSubmit = () => {
    var form = this.state.form;
    form["reorder_flag"] = this.state.InStock;

    console.log(this.state.form);
    // this.props.submit(this.state.form);
  };
  handleInputChange = (event) => {
    var name = event.target.name;
    var value = event.target.value;
    var form = this.state.form;
    console.log(name);

    form[name] = value;
    this.setState(form);
    console.log(this.state.form);
  };
  handleDateChange(name, value) {
    var form = this.state.form;
    form[name] = moment(value).format("YYYY-MM-DD HH:mm");
    this.setState(form);
  }
  render() {
    const {
      // loading,
      title,
      // statusbtn,
      // data,
      // startDate,
      // options,
      form,
    } = this.state;

    return (
      <LayoutOperation title={title}>
        {/*  ============================== Header Page  ==============================*/}

        <div className="row mb-2">
          <div className="col-sm-6 mt-3 ">
            <a
              href="#"
              className="ml-5  text-dark"
              style={{ color: "#2B2D33", fontSize: "18px", textAlign: "left" }}
            >
              {" "}
              {"< "} Back
            </a>
          </div>
          <div className="col-sm-6">
            <ol
              className="breadcrumb float-sm-right mr-5  mt-3"
              style={{ background: "inherit" }}
            >
              <li className="breadcrumb-item">MA List</li>
              <li className="breadcrumb-item">
                <a href="#">ADD MATERIAL</a>
              </li>
            </ol>
          </div>
        </div>
        {/*  ==============================  Page  Body ==============================*/}
        <div className="container mb-2" style={{ maxWidth: "95%" }}>
          <div className="row">
            <div className="col-12 mt-2 ">
              <span style={{ color: "#0500A3", fontSize: "16px" }}>
                <img
                  src={Api.absoluteUrl("/icon/pust.svg")}
                  width="14"
                  className="mr-2"
                  alt="plust-ic"
                />
                <b> ADD MATERIAL </b>
              </span>
              <div className="card mt-2" style={{ width: "95%" }}>
                <div className="card-body">
                  {/* ========================================  Import Manual ===================================== */}
                  <div>
                    <div className="row">
                      <div className="col-3"> </div>

                      <div className="col-7"></div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Material Test.
                            </label>{" "}
                            <br />{" "}
                            <Select
                              style={{ display: "block" }}
                              defaultValue=""
                              //   className="dropdrowtype"
                              //   onChange={this.onSelectJobType}
                              value={form.meterial_list}
                              // className="dropdrowtype"
                              onChange={(value) =>
                                this.handleSelectChange("material_type", value)
                              }
                            >
                              <Select.Option value="" disabled>
                                Please select
                              </Select.Option>
                              {this.state.meterial_list.map((item, index) => (
                                <Select.Option
                                  key={index}
                                  value={item.material_id}
                                >
                                  {item.material_name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Material Name.{" "}
                              <b style={{ color: "#DF4547" }}>*</b>
                            </label>{" "}
                            <br />{" "}
                            <input
                              typ="text"
                              className="inputfile"
                              style={{ width: "100%" }}
                              name="material_name"
                              onChange={this.handleInputChange}
                            ></input>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Material No. <b style={{ color: "#DF4547" }}>*</b>
                            </label>{" "}
                            <br />{" "}
                            <input
                              typ="text"
                              className="inputfile"
                              style={{ width: "100%" }}
                              name="material_code"
                              onChange={this.handleInputChange}
                            ></input>
                          </div>
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Model No. <b style={{ color: "#DF4547" }}>*</b>
                            </label>{" "}
                            <br />{" "}
                            <input
                              typ="text"
                              className="inputfile"
                              style={{ width: "100%" }}
                              name="model_no"
                              onChange={this.handleInputChange}
                            ></input>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-12">
                            {" "}
                            <label className="labeaddjob">
                              Description
                            </label>{" "}
                            <br />{" "}
                            <textarea
                              style={{ width: "100%", height: "80px" }}
                              name="description"
                              onChange={this.handleInputChange}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Unit <b style={{ color: "#DF4547" }}>*</b>
                            </label>{" "}
                            <br />{" "}
                            <Select
                              defaultValue=""
                              //   className="dropdrowtype"
                              //   onChange={this.onSelectJobType}
                              value={form.unit_type}
                              // className="dropdrowtype"
                              onChange={(value) =>
                                this.handleSelectChange("unit_id", value)
                              }
                            >
                              <Select.Option value="" disabled>
                                Please select
                              </Select.Option>
                              {this.state.unit_type.map((item, index) => (
                                <Select.Option key={index} value={item.unit_id}>
                                  {item.unit_name_thai}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Unit Price <b style={{ color: "#DF4547" }}>*</b>
                            </label>{" "}
                            <br />{" "}
                            <input
                              typ="text"
                              className="inputfile"
                              style={{ width: "100%" }}
                              name="avg_price"
                              onChange={this.handleInputChange}
                            ></input>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Effective Date
                            </label>{" "}
                            <br />{" "}
                            <DatePicker
                              className="datepicker"
                              selected={this.state.expireDate}
                              onChange={(value) =>
                                this.handleDateChange("effective_date", value)
                              }
                            />
                          </div>
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Warranty Expire Date
                            </label>{" "}
                            <br />{" "}
                            <DatePicker
                              className="datepicker"
                              selected={this.state.expireDate}
                              onChange={(value) =>
                                this.handleDateChange("expire_date", value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Brand <b style={{ color: "#DF4547" }}>*</b>
                            </label>{" "}
                            <br />{" "}
                            <input
                              typ="text"
                              className="inputfile"
                              style={{ width: "100%" }}
                              name="brand"
                              onChange={this.handleInputChange}
                            ></input>
                          </div>
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Supplier <b style={{ color: "#DF4547" }}>*</b>{" "}
                            </label>{" "}
                            <br />{" "}
                            <Select
                              defaultValue=""
                              //   className="dropdrowtype"
                              //   onChange={this.onSelectJobType}
                              value={form.get_supplire}
                              // className="dropdrowtype"
                              onChange={(value) =>
                                this.handleSelectChange("supplire_list", value)
                              }
                            >
                              <Select.Option value="" disabled>
                                Please select
                              </Select.Option>
                              {this.state.get_supplire.map((item, index) => (
                                <Select.Option
                                  key={index}
                                  value={item.supplier_id}
                                >
                                  {item.supplier_name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Model Number <b style={{ color: "#DF4547" }}>*</b>{" "}
                            </label>{" "}
                            <br />{" "}
                            <input
                              typ="text"
                              className="inputfile"
                              style={{ width: "100%" }}
                              name="model_no"
                              onChange={this.handleInputChange}
                            ></input>
                          </div>
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              S/N <b style={{ color: "#DF4547" }}>*</b>
                            </label>{" "}
                            <br />{" "}
                            <input
                              typ="text"
                              className="inputfile"
                              style={{ width: "100%" }}
                              name="serial_no"
                              onChange={this.handleInputChange}
                            ></input>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-12">
                            {" "}
                            <label className="labeaddjob">
                              Remark
                            </label> <br />{" "}
                            <textarea
                              style={{ width: "100%", height: "80px" }}
                              name="remark"
                              onChange={this.handleInputChange}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Reorder Alert{" "}
                              <b style={{ color: "#DF4547" }}>*</b>
                            </label>{" "}
                            <br />{" "}
                            <Radio.Group onChange={this.onChange}>
                              <Radio value={1} className="mt-2">
                                {" "}
                                Alert{" "}
                              </Radio>
                              <Radio value={0} className="mt-2">
                                {" "}
                                No Alert{" "}
                              </Radio>
                            </Radio.Group>{" "}
                            {/* <input type="radio" value="option1" />
                            <span
                              style={{
                                marginLeft: "10px",
                                marginRight: "20px",
                                color: "#0500A3",
                                fontWeight: 700,
                              }}
                            >
                              {" "}
                              In Stock
                            </span>
                            <input type="radio" value="option2" />
                            <span
                              style={{
                                marginLeft: "10px",
                                color: "#0500A3",
                                fontWeight: 700,
                              }}
                            >
                              {" "}
                              Out Of Stock
                            </span> */}
                          </div>
                          <div className="col-6"></div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col-6">
                            {" "}
                            <label className="labeaddjob">
                              Minimun Stock on hand{" "}
                              <b style={{ color: "#DF4547" }}>*</b>
                            </label>{" "}
                            <br />{" "}
                            <input
                              typ="text"
                              className="inputfile"
                              style={{ width: "100%" }}
                              name="minimun_qty"
                              onChange={this.handleInputChange}
                            ></input>
                          </div>
                          <div className="col-6"></div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div style={{ textAlign: "center" }} className="mt-5">
                      <button type="button" class="btncancel mr-3">
                        <span style={{ fontSize: "16px" }}>Cancel</span>
                      </button>
                      <button
                        type="button"
                        class="btnadd ml-3"
                        onClick={this.handleSubmit}
                      >
                        <span style={{ fontSize: "16px" }}>Add</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOperation>
    );
  }
}

const mapStateToProps = (state) => ({
  get_material: state.task_jobtype.get_material,
  get_supplire: state.task_jobtype.get_supplire,
  get_unit: state.task_jobtype.get_unit,
});
const mapDispacthToProps = (dispatch) => {
  return {
    // Getmaterial: () => dispatch(Getmaterial()),
    // Getsupplire: () => dispatch(Getsupplire()),
    // GetUnit: () => dispatch(GetUnit()),
    // submit: (data) => {
    //   dispatch(AddMaterial(data));
    // },
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(Addmaterial);
